import React from 'react';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Linkedin, Twitter, Flame } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const navigate = useNavigate();

    const quickLinks = [
        { id: '/', label: 'Início' },
        { id: 'produtos', label: 'Produtos' },
        { id: 'cursos', label: 'Cursos' },
        { id: 'certificados', label: 'Certificados' },
        { id: 'sobre', label: 'Sobre Nós' }
    ];

    return (
        <footer className="footer" aria-label="Rodapé do site">
            <div className="footer-content">
                <div className="footer-grid">
                    {/* Company Info */}
                    <div className="footer-section company-info">
                        <div className="footer-brand">
                            <div className="footer-logo">
                                <div className="flame-icon" aria-hidden="true"><Flame size={20} /></div>
                                <div className="brand-text">
                                    <h3>Fire Safety</h3>
                                    <span>Moçambique</span>
                                </div>
                            </div>
                            <p className="footer-description">
                                Especialistas em segurança contra incêndios em Moçambique.
                                Oferecemos soluções completas para proteger vidas e patrimônios
                                com equipamentos de alta qualidade e serviços profissionais.
                            </p>
                            <div className="social-links">
                                <a href="https://facebook.com" className="social-link" aria-label="Facebook">
                                    <Facebook size={20} />
                                </a>
                                <a href="https://instagram.com" className="social-link" aria-label="Instagram">
                                    <Instagram size={20} />
                                </a>
                                <a href="https://linkedin.com" className="social-link" aria-label="LinkedIn">
                                    <Linkedin size={20} />
                                </a>
                                <a href="https://twitter.com" className="social-link" aria-label="Twitter">
                                    <Twitter size={20} />
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="footer-section">
                        <h4>Links Rápidos</h4>
                        <ul className="footer-links">
                            {quickLinks.map(link => (
                                <li key={link.id}>
                                    <button
                                        className="footer-link"
                                        onClick={() => navigate(link.id)}
                                        aria-label={`Navegar para ${link.label}`}
                                    >
                                        {link.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div className="footer-section">
                        <h4>Contacte-nos</h4>
                        <div className="contact-details">
                            <div className="contact-detail">
                                <MapPin size={18} aria-hidden="true" />
                                <div>
                                    <strong>Endereço:</strong>
                                    <p>AV.Olof Palme nº245, 1º andar<br />Maputo, Moçambique</p>
                                </div>
                            </div>
                            <div className="contact-detail">
                                <Phone size={18} aria-hidden="true" />
                                <div>
                                    <strong>Telefone:</strong>
                                    <p>+258 87 704 1104</p>
                                </div>
                            </div>
                            <div className="contact-detail">
                                <Mail size={18} aria-hidden="true" />
                                <div>
                                    <strong>Email:</strong>
                                    <p>adm@firesafety.co.mz</p>
                                </div>
                            </div>
                            <div className="contact-detail">
                                <Clock size={18} aria-hidden="true" />
                                <div>
                                    <strong>Horário:</strong>
                                    <p>Seg - Sex: 8:00 - 17:00<br />Sáb: 8:00 - 14:00</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="footer-bottom">
                    <div className="footer-bottom-content">
                        <p>&copy; {currentYear} Fire Safety Moçambique. Todos os direitos reservados.</p>
                        <div className="footer-bottom-links">
                            <a href="https://tobiasjunior.vercel.app" >Desenvolvido por Tobias Júnior</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
